export default __webpack_public_path__ + "static/media/21.150e5d8b.svg";